import type { ComponentPropsWithoutRef } from "react";

import { tw } from "~/utils";

export const ClockIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    className={tw(className)}
    width="117"
    height="116"
    viewBox="0 0 117 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.3"
      d="M58.3467 115.965C26.3325 115.965 0.379846 90.0127 0.379845 57.9985C0.379844 25.9843 26.3325 0.0317066 58.3467 0.0317052C90.3609 0.0317038 116.314 25.9843 116.314 57.9985C116.314 90.0127 90.3609 115.965 58.3467 115.965Z"
      fill="#AEC6B1"
      stroke="#7A5241"
      strokeWidth="0.0663357"
    />
    <path
      opacity="0.7"
      d="M58.3467 96.0279C37.3437 96.0279 20.3173 79.0016 20.3173 57.9985C20.3173 36.9955 37.3437 19.9692 58.3467 19.9692C79.3497 19.9692 96.376 36.9955 96.376 57.9985C96.376 79.0016 79.3497 96.0279 58.3467 96.0279Z"
      fill="#AEC6B1"
      stroke="#7A5241"
      strokeWidth="0.0663357"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.3468 38.4385C47.5441 38.4385 38.7869 47.1957 38.7869 57.9984C38.7869 68.801 47.5441 77.5583 58.3468 77.5583C69.1494 77.5583 77.9067 68.801 77.9067 57.9984C77.9067 47.1957 69.1494 38.4385 58.3468 38.4385ZM35.615 57.9984C35.615 45.444 45.7923 35.2666 58.3468 35.2666C70.9012 35.2666 81.0785 45.444 81.0785 57.9984C81.0785 70.5528 70.9012 80.7301 58.3467 80.7301C45.7923 80.7301 35.615 70.5528 35.615 57.9984ZM58.3468 47.9541C59.2226 47.9541 59.9327 48.6641 59.9327 49.54V57.3415L64.7546 62.1634C65.374 62.7827 65.374 63.7869 64.7546 64.4063C64.1353 65.0256 63.1311 65.0256 62.5118 64.4063L57.2253 59.1198C56.9279 58.8224 56.7608 58.419 56.7608 57.9984V49.54C56.7608 48.6641 57.4709 47.9541 58.3468 47.9541Z"
      fill="#262608"
    />
  </svg>
);
